import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { BranchData } from '@/common/types/cards/details.type'
import { CreatorType, TicketData } from '@/common/types/support/ticket.type'
import { BriefcaseBusinessIcon, UserRoundIcon } from 'lucide-react'

type SupportTicketCreatorProps = {
  creator: TicketData['creator']
  creator_type: CreatorType;
  branch: BranchData;
}

export const SupportTicketCreator = ({ creator, creator_type, branch }: SupportTicketCreatorProps) => {
  const isFromAdmin = creator_type === CreatorType.AdminUser;

  return (
    <div className="flex gap-2 items-center">
      <ImageWithPlaceholder
        url={creator?.profile_picture?.url}
        alt={creator?.full_name}
        placeholderIcon={UserRoundIcon}
        className="size-6"
        iconClassName="size-4"
      />

      <p className="text-xs">
        {creator?.full_name}
      </p>

      {isFromAdmin ? (
        <p className='text-sm font-light italic'>(Agente Tcard)</p>
      ) : (
        <div className="flex gap-1 items-center">
          <ImageWithPlaceholder
            url={branch?.general_information?.company_logo?.url}
            alt={branch?.display_name}
            placeholderIcon={BriefcaseBusinessIcon}
          />

          <p className="text-[10px] font-light italic">
            {branch?.display_name}
          </p>
        </div>
      )}
    </div>
  )
}
